<template>
    <v-menu
        top
        right
        v-model="formPopup"
        :close-on-click="true"
        :close-on-content-click="false"
        offset-y
        transition="slide-x-reverse-transition"
    >
        <template v-slot:activator="{ on }">
            <v-badge
                color="green"
                :content="formEmployeeId.length"
                overlap
                offset-x="20"
                offset-y="15"
                :value="!!formEmployeeId.length"
                style="position: fixed; right: 12px; bottom: 110px; z-index: 5;"
            >
                <v-btn
                    color="blue"
                    large
                    fab
                    v-on="on"
                >
                    <v-icon icon v-if="!formPopup" color="white">$addUser</v-icon>
                    <v-icon icon v-else color="white">mdi-close</v-icon>
                </v-btn>
            </v-badge>
        </template>
        <v-card min-width="300px" class="pa-5">
            <v-form ref="moveForm">
                <div class="mb-2">Add Rota record</div>
                <div class="error--text mb-2" v-if="errorMessage.length > 0">
                    {{errorMessage}}
                </div>
                <v-autocomplete
                    :items="$store.getters.getEmployeesSorted"
                    item-text="fullName"
                    item-value="id"
                    v-model="formEmployeeId"
                    placeholder="Employee"
                    solo
                    dense
                    lighten-1
                    class="mb-3"
                    multiple
                    return-object
                    :search-input.sync="searchInputAutocomplete[selectInputConst.rota]"
                    @change="changeOption(selectInputConst.rota)"
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="selection-text-style">{{ item.fullName }}</span>
                        <span
                            v-if="index === 1"
                            class="grey--text caption"
                        >(+{{ formEmployeeId.length - 1 }} others)</span>
                    </template>
                </v-autocomplete>
                <v-menu
                    v-model="openDatePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="Date.formatDate([formDate])"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="formDate" @input="openDatePicker = false"></v-date-picker>
                </v-menu>
                <v-autocomplete
                    :items="getClinics"
                    item-text="title"
                    item-value="id"
                    v-model="formClinicId"
                    placeholder="Clinic"
                    solo
                    dense
                    lighten-1
                    @change="clinicChangeHandler"
                    class="mb-3"
                ></v-autocomplete>
                <v-autocomplete
                    :items="$store.getters.getRoles"
                    item-text="title"
                    item-value="id"
                    v-model="formRoleId"
                    placeholder="Roles"
                    solo
                    dense
                    lighten-1
                    class="mb-3"
                ></v-autocomplete>
                <v-autocomplete
                    :items="designatorsList"
                    v-model="formDesignator"
                    placeholder="Designator"
                    solo
                    dense
                    lighten-1
                    class="mb-3"
                ></v-autocomplete>
                <v-autocomplete
                    :items="clinicSurgeries"
                    clearable
                    item-text="value"
                    item-value="id"
                    v-model="formSurgeryId"
                    placeholder="Sub-unit"
                    solo
                    dense
                    lighten-1
                    class="mb-3"
                ></v-autocomplete>
                <div class="mb-3 font-weight-bold">Note:</div>
                <v-flex class="pb-5">
                    <v-textarea
                        outlined
                        v-model="noteText"
                        hint="Enter comment"
                        rows="3"
                    ></v-textarea>
                </v-flex>
                <v-btn @click="formSubmit">
                    Create
                </v-btn>
            </v-form>
        </v-card>
    </v-menu>
</template>
<script>
    import { ROTA_STATUSES } from '@/common/constants'
    import { STATUSES_HOLIDAY, TYPES_HOLIDAY } from '@/constatns/typesOfHolidays'
    import { mapActions, mapGetters } from 'vuex'
    import selectInputAutocomplete from '../../../constatns/selectInputAutocomplete'

    export default {
        name: 'AddRotaRecord',
        props: ['selectedItems', 'unSelectItem', 'transferAction', 'clearSelectedList'],
        data: () => ({
            formPopup: false,
            formRoleId: null,
            formClinicId: null,
            formSurgeryId: null,
            errorMessage: '',
            formData: null,
            status: ROTA_STATUSES.working,
            openDatePicker: false,
            formEmployeeId: [],
            formDate: new Date().toISOString().substr(0, 10),
            formDesignator: 'AM',
            designatorsList: ['AM', 'PM'],
            noteText: '',
            selectInputConst: selectInputAutocomplete,
            searchInputAutocomplete: {
                [selectInputAutocomplete.rota]: null
            }
        }),
        computed: {
            ...mapGetters(['getPersonalRota', 'getClinicSurgeries', 'getClinics', 'getUserActiveGroup']),
            clinicSurgeries () {
                return this.getClinicSurgeries(this.formClinicId)
            },
            clinicRules () {
                const rules = []
                if (!this.status && !this.formRoleId && !this.formClinicId) {
                    rules.push(val => !!val || 'Clinic is required!')
                }
                return rules
            }
        },
        watch: {
            getUserActiveGroup: function () {
                this.loadEmployees()
            },
            selectedItems: function () {
                this.formEmployeeId = this.selectedItems.reduce((acc, item) => {
                    if (acc.length === 0) {
                        acc.push({
                            id: item.employeeId,
                            fullName: item.employeeName,
                            templateId: item.templateId,
                            entityId: item.entityId,
                            roleId: item.roleId,
                            clinicId: item.clinicId
                        })
                    } else {
                        const isAdded = acc.find(employee => employee.id === item.employeeId)
                        if (!isAdded) {
                            acc.push({
                                id: item.employeeId,
                                fullName: item.employeeName,
                                templateId: item.templateId,
                                entityId: item.entityId,
                                roleId: item.roleId,
                                clinicId: item.clinicId
                            })
                        }
                    }
                    return acc
                }, [])
                if (this.selectedItems.length === 1) {
                    this.formDate = this.selectedItems[0].date
                }
            }
        },
        methods: {
            ...mapActions(['reassignPersonalRota', 'fetchEmployees', 'fetchCheckDate', 'showAlert']),
            clinicChangeHandler () {
                this.formSurgeryId = null
            },
            async formSubmit () {
                this.errorMessage = ''
                if (!this.formEmployeeId.length && !this.formRoleId && !this.formClinicId) {
                    this.errorMessage = 'All fields are required!'
                    return
                }
                this.formData = this.createFormData()
                const employeeIds = this.formData.map(item => item.employeeId)
                const params = {
                    employeeIds: employeeIds,
                    date: this.formData[0].date
                }
                try {
                    const responseHolidaysOfUser = await this.fetchCheckDate({ data: params })
                    const responseHolidays = responseHolidaysOfUser.data.holidays
                    if (!responseHolidays.length) {
                        this.saveData(this.formData)
                        return
                    }

                    const isExistRequest = responseHolidays.some((item) => item.status === 'Request')
                    const isExistApproveLevel1 = responseHolidays.some((item) => item.status === STATUSES_HOLIDAY.APPROVED_LEVEL_1_NAME)
                    const isExistApproveLevel2 = responseHolidays.some((item) => item.status === STATUSES_HOLIDAY.APPROVED_LEVEL_2_NAME)

                    const defaultOptions = {
                        type: 'info',
                        action: 'save',
                        agreeBtnText: 'Create',
                        text: 'Do you really want to create ?'
                    }

                    if (responseHolidays[0].type === TYPES_HOLIDAY.SICK_LEAVE_NAME && responseHolidays[0].isLocked === false) {
                        const description = "The record will be virtually placed to the destination, but you won't be able to see this until ongoing sickness is locked. Until then all records will be displayed in OFF"
                        if (await this.$root.$confirmDialog.open(null, defaultOptions, description)) {
                            this.saveData(this.formData)
                        }
                        return
                    }

                    if ((responseHolidays[0].type === TYPES_HOLIDAY.SICK_LEAVE_NAME && responseHolidays[0].isLocked === true) ||
                        responseHolidays[0].type === TYPES_HOLIDAY.DEPENDENT_ABSENCE_NAME ||
                        responseHolidays[0].type === TYPES_HOLIDAY.UNAUTHORIZED_ABSENCE_NAME ||
                        responseHolidays[0].type === TYPES_HOLIDAY.MATERNITY_LEAVE_NAME) {
                          if (this.formDesignator === responseHolidays[0].designator) {
                            const description = 'Employee has an overlapping leave or absence'
                            this.showAlert({
                                text: description,
                                type: 'error'
                            })
                            return
                          }
                    }

                    if (isExistRequest) {
                        const description = "A holiday request overlapping selected date(s) exists. Changing the Rota might affect employee's expectations. Create?"
                        if (await this.$root.$confirmDialog.open(null, defaultOptions, description)) {
                            this.saveData(this.formData)
                        }
                        return
                    }

                    if (isExistApproveLevel1 || isExistApproveLevel2) {
                      if (this.formDesignator === responseHolidays[0].designator) {
                        const description = 'Existing holiday or absence overlaps an approved holiday. No Rota actions allowed while holiday is approved in order to prevent a possible confusion'
                        this.showAlert({
                            text: description,
                            type: 'error'
                        })
                        return
                      }
                    }

                    this.saveData(this.formData)
                } catch (e) {
                    console.log(e)
                }
            },
            async saveData (formData) {
                try {
                    await this.transferAction({
                        records: formData
                    })
                    this.formPopup = false
                    this.formEmployeeId = []
                    this.formDate = new Date().toISOString().substr(0, 10)
                    this.formClinicId = null
                    this.formRoleId = null
                    this.formDesignator = 'AM'
                    this.formSurgeryId = null
                    this.noteText = ''
                    this.$emit('successSubmit', 'Successfully created!')
                } catch (e) {
                    console.log(e)
                }
            },
            createFormData () {
                return this.formEmployeeId.map(item => {
                    const status = this.status ? this.status : ROTA_STATUSES.working

                    return {
                        date: this.formDate,
                        designator: this.formDesignator,
                        employeeId: item.id,
                        status,
                        roleId: this.formRoleId ? this.formRoleId : item.roleId,
                        clinicId: status === ROTA_STATUSES.working ? this.formClinicId ? this.formClinicId : item.clinicId : null,
                        surgeryId: status === ROTA_STATUSES.working ? this.formSurgeryId ? this.formSurgeryId : this.surgeryId : null,
                        isExtra: true,
                        note: this.noteText
                    }
                })
            },
            async loadEmployees () {
                await this.fetchEmployees({
                    getAll: true,
                    itemsPerPage: 1000,
                    pageNumber: 1,
                    groups: [this.getUserActiveGroup]
                })
            },
            changeOption (typeSearch) {
                this.searchInputAutocomplete[typeSearch] = ''
            }
        },
        async mounted () {
            this.loadEmployees()
        }
    }
</script>
